var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDragHandle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5,11 C6.1045695,11 7,11.8954305 7,13 C7,14.1045695 6.1045695,15 5,15 C3.8954305,15 3,14.1045695 3,13 C3,11.8954305 3.8954305,11 5,11 Z M11,11 C12.1045695,11 13,11.8954305 13,13 C13,14.1045695 12.1045695,15 11,15 C9.8954305,15 9,14.1045695 9,13 C9,11.8954305 9.8954305,11 11,11 Z M5,6 C6.1045695,6 7,6.8954305 7,8 C7,9.1045695 6.1045695,10 5,10 C3.8954305,10 3,9.1045695 3,8 C3,6.8954305 3.8954305,6 5,6 Z M11,6 C12.1045695,6 13,6.8954305 13,8 C13,9.1045695 12.1045695,10 11,10 C9.8954305,10 9,9.1045695 9,8 C9,6.8954305 9.8954305,6 11,6 Z M5,1 C6.1045695,1 7,1.8954305 7,3 C7,4.1045695 6.1045695,5 5,5 C3.8954305,5 3,4.1045695 3,3 C3,1.8954305 3.8954305,1 5,1 Z M11,1 C12.1045695,1 13,1.8954305 13,3 C13,4.1045695 12.1045695,5 11,5 C9.8954305,5 9,4.1045695 9,3 C9,1.8954305 9.8954305,1 11,1 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragHandle);
export default __webpack_public_path__ + "static/media/drag-handle.23bab6d4b83f7ff9e320018193f91d1b.svg";
export { ForwardRef as ReactComponent };